import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./banner-carousel.${locale}.json`));
